var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.28,
    height: 119.199,
    viewBox: "0 0 107.28 119.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Content_Writing",
    "data-name": "Content Writing",
    d: "M123.6,155.906a5.96,5.96,0,0,1-5.96,5.96H69.96a5.96,5.96,0,0,1-5.96-5.96V48.627a5.96,5.96,0,0,1,5.96-5.96H153.4a5.96,5.96,0,0,1,5.96,5.96v47.68a5.96,5.96,0,1,1-11.92,0V54.587H75.92v95.36h41.72a5.96,5.96,0,0,1,5.96,5.96Zm47.68-16.867a5.96,5.96,0,0,1-1.728,4.231l-16.867,16.867a6.021,6.021,0,0,1-8.463,0L102.144,118a5.961,5.961,0,0,1-1.609-3.04L96.3,93.863a5.96,5.96,0,0,1,7.033-7.033l21.1,4.231a5.961,5.961,0,0,1,3.04,1.609l42.137,42.137A5.96,5.96,0,0,1,171.279,139.04Zm-59.6-28.191,22.827,22.767,8.463-8.4-22.648-22.946-10.549-2.086ZM156.8,139.04l-5.423-5.424-8.463,8.463,5.424,5.423Zm-63-72.533a5.96,5.96,0,0,0,0,11.92h35.76a5.96,5.96,0,1,0,0-11.92Z",
    transform: "translate(-64 -42.667)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/Content.e818eaa481c7ab2f44ef87bba8a9459c.svg";
export { ForwardRef as ReactComponent };